module.exports = __webpack_public_path__ + "static/img/channel1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/channel1.png
// module id = 543
// module chunks = 0